// Lifecycle policy (super-admin /super-admin/hq/automation): the data-testid registry.
//
// The frontend lane renders these ids and the jest suites and the browser-qa journey read
// them. Ids that depend on a row or a policy path are functions, so the two sides cannot
// disagree on the separator. Contract: docs/automation-module/lifecycle-policy-contract.md §9.

// A dotted policy path ("trial.reminders.enabled") as an id fragment ("trial-reminders-enabled").
const pathId = (path) => String(path).replace(/[._]/g, "-");

export const LIFECYCLE = Object.freeze({
  // ── tab shell (HqAutomation.jsx) ──
  tabs: "hq-automation-tabs",
  tabLifecycle: "hq-automation-tab-lifecycle",
  tabCustomRules: "hq-automation-tab-custom-rules",

  // ── panel states ──
  panel: "lifecycle-panel",
  loading: "lifecycle-loading",
  loadError: "lifecycle-load-error",
  retry: "lifecycle-retry",
  lastSaved: "lifecycle-last-saved",               // "Last saved {at} by {email}"; absent when never saved

  // ── trial section ──
  trialLength: "lifecycle-trial-length",           // <input type=number>
  leadDaysEditor: "lifecycle-lead-days",
  leadDay: (i) => `lifecycle-lead-day-${i}`,        // chip i (display order)
  leadDayRemove: (i) => `lifecycle-lead-day-remove-${i}`,
  leadDayInput: "lifecycle-lead-day-input",
  leadDayAdd: "lifecycle-lead-day-add",            // disabled at max_reminders

  // ── dunning section ──
  graceDays: "lifecycle-grace-days",               // <input type=number>
  followUpEditor: "lifecycle-follow-ups",
  followUp: (i) => `lifecycle-follow-up-${i}`,
  followUpRemove: (i) => `lifecycle-follow-up-remove-${i}`,
  followUpInput: "lifecycle-follow-up-input",
  followUpAdd: "lifecycle-follow-up-add",          // disabled at max_follow_ups

  // ── email toggles: one per contract.EMAIL_TOGGLES path ──
  toggle: (path) => `lifecycle-toggle-${pathId(path)}`, // role=switch, aria-checked

  // ── violations: one per (field) with at least one violation ──
  fieldError: (path) => `lifecycle-error-${pathId(path)}`,
  formError: "lifecycle-form-error",               // top-level code text (REAUTH_REQUIRED, unknown)

  // ── save bar ──
  save: "lifecycle-save",                          // disabled while !dirty or saving
  reset: "lifecycle-reset",                        // disabled while !dirty
  dirtyBadge: "lifecycle-dirty",
  savedToast: "lifecycle-saved",

  // ── Stripe-controlled note ──
  stripeNote: "lifecycle-stripe-note",

  // ── upcoming sends ──
  upcoming: "lifecycle-upcoming",
  upcomingRow: (i) => `lifecycle-upcoming-row-${i}`, // data-moment
  upcomingEmpty: "lifecycle-upcoming-empty",
  runNow: "lifecycle-run-now",
  runResult: "lifecycle-run-result",               // "{sent} sent · {skipped} skipped · {failed} failed"

  // ── recent sends ──
  sends: "lifecycle-sends",
  sendRow: (id) => `lifecycle-send-${id}`,          // data-outcome
  sendsEmpty: "lifecycle-sends-empty",
});
